export interface CountryType {
  code: string;
  label: string;
  phone: string;
  currency: string;
  suggested?: boolean;
  noRegions?: boolean;
  isEU?: boolean;
}

export const countryTemplates = {
  UK: 'uk',
  TW: 'tw',
  IT: 'it',
};

const countries: readonly CountryType[] = [
  {
    code: 'US',
    label: 'United States',
    phone: '+1',
    currency: 'USD',
    suggested: true,
  }, // Ordered first on purpose
  { code: 'AF', label: 'Afghanistan', phone: '+93', currency: 'AFN' },
  { code: 'AL', label: 'Albania', phone: '+355', currency: 'ALL' },
  { code: 'DZ', label: 'Algeria', phone: '+213', currency: 'DZD' },
  { code: 'AS', label: 'American Samoa', phone: '+1-684', currency: 'USD', noRegions: true },
  { code: 'AD', label: 'Andorra', phone: '+376', currency: 'EUR' },
  { code: 'AO', label: 'Angola', phone: '+244', currency: 'AOA' },
  { code: 'AI', label: 'Anguilla', phone: '+1-264', currency: 'XCD', noRegions: true },
  { code: 'AQ', label: 'Antarctica', phone: '+672', currency: 'N/A', noRegions: true },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '+1-268',
    currency: 'XCD',
  },
  { code: 'AR', label: 'Argentina', phone: '+54', currency: 'ARS' },
  { code: 'AM', label: 'Armenia', phone: '+374', currency: 'AMD' },
  { code: 'AW', label: 'Aruba', phone: '+297', currency: 'AWG', noRegions: true },
  {
    code: 'AU',
    label: 'Australia',
    phone: '+61',
    currency: 'AUD',
    suggested: true,
  },
  { code: 'AT', label: 'Austria', phone: '+43', currency: 'EUR', isEU: true },
  { code: 'AZ', label: 'Azerbaijan', phone: '+994', currency: 'AZN' },
  { code: 'BS', label: 'Bahamas', phone: '+1-242', currency: 'BSD' },
  { code: 'BH', label: 'Bahrain', phone: '+973', currency: 'BHD' },
  { code: 'BD', label: 'Bangladesh', phone: '+880', currency: 'BDT' },
  { code: 'BB', label: 'Barbados', phone: '+1-246', currency: 'BBD' },
  { code: 'BY', label: 'Belarus', phone: '+375', currency: 'BYN' },
  { code: 'BE', label: 'Belgium', phone: '+32', currency: 'EUR', isEU: true },
  { code: 'BZ', label: 'Belize', phone: '+501', currency: 'BZD' },
  { code: 'BJ', label: 'Benin', phone: '+229', currency: 'XOF' },
  { code: 'BM', label: 'Bermuda', phone: '+1-441', currency: 'BMD', noRegions: true },
  { code: 'BT', label: 'Bhutan', phone: '+975', currency: 'BTN' },
  { code: 'BO', label: 'Bolivia', phone: '+591', currency: 'BOB' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '+387',
    currency: 'BAM',
  },
  { code: 'BW', label: 'Botswana', phone: '+267', currency: 'BWP' },
  { code: 'BR', label: 'Brazil', phone: '+55', currency: 'BRL' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '+246',
    currency: 'USD',
    noRegions: true,
  },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '+1-284',
    currency: 'USD',
    noRegions: true,
  },
  { code: 'BN', label: 'Brunei Darussalam', phone: '+673', currency: 'BND' },
  { code: 'BG', label: 'Bulgaria', phone: '+359', currency: 'EUR', isEU: true },
  { code: 'BF', label: 'Burkina Faso', phone: '+226', currency: 'XOF' },
  { code: 'BI', label: 'Burundi', phone: '+257', currency: 'BIF' },
  { code: 'KH', label: 'Cambodia', phone: '+855', currency: 'KHR' },
  { code: 'CM', label: 'Cameroon', phone: '+237', currency: 'XAF' },
  { code: 'CA', label: 'Canada', phone: '+1', currency: 'CAD' },
  {
    code: 'IC',
    label: 'Canary Islands',
    phone: '+34',
    currency: 'EUR',
    isEU: true,
    noRegions: true,
  },
  { code: 'CV', label: 'Cape Verde', phone: '+238', currency: 'CVE' },
  { code: 'KY', label: 'Cayman Islands', phone: '+1-345', currency: 'KYD', noRegions: true },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '+236',
    currency: 'XAF',
  },
  { code: 'TD', label: 'Chad', phone: '+235', currency: 'XAF' },
  { code: 'CL', label: 'Chile', phone: '+56', currency: 'CLP' },
  { code: 'CN', label: 'China', phone: '+86', currency: 'CNY' },
  { code: 'CO', label: 'Colombia', phone: '+57', currency: 'COP' },
  { code: 'KM', label: 'Comoros', phone: '+269', currency: 'KMF' },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '+243',
    currency: 'CDF',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '+242',
    currency: 'XAF',
  },
  { code: 'CK', label: 'Cook Islands', phone: '+682', currency: 'NZD', noRegions: true },
  { code: 'CR', label: 'Costa Rica', phone: '+506', currency: 'CRC' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '+225', currency: 'XOF' },
  { code: 'HR', label: 'Croatia', phone: '+385', currency: 'HRK', isEU: true },
  { code: 'CW', label: 'Curacao', phone: '+599', currency: 'ANG', noRegions: true },
  { code: 'CY', label: 'Cyprus', phone: '+357', currency: 'EUR', isEU: true },
  { code: 'CZ', label: 'Czech Republic', phone: '+420', currency: 'CZK', isEU: true },
  { code: 'DK', label: 'Denmark', phone: '+45', currency: 'DKK', isEU: true },
  { code: 'DJ', label: 'Djibouti', phone: '+253', currency: 'DJF' },
  { code: 'DM', label: 'Dominica', phone: '+1-767', currency: 'XCD' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '+1-809',
    currency: 'DOP',
  },
  { code: 'EC', label: 'Ecuador', phone: '+593', currency: 'USD' },
  { code: 'EG', label: 'Egypt', phone: '+20', currency: 'EGP' },
  { code: 'SV', label: 'El Salvador', phone: '+503', currency: 'USD' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '+240', currency: 'XAF' },
  { code: 'ER', label: 'Eritrea', phone: '+291', currency: 'ERN' },
  { code: 'EE', label: 'Estonia', phone: '+372', currency: 'EUR', isEU: true },
  { code: 'ET', label: 'Ethiopia', phone: '+251', currency: 'ETB' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '+500',
    currency: 'FKP',
    noRegions: true,
  },
  { code: 'FO', label: 'Faroe Islands', phone: '+298', currency: 'DKK', noRegions: true },
  { code: 'FJ', label: 'Fiji', phone: '+679', currency: 'FJD' },
  { code: 'FI', label: 'Finland', phone: '+358', currency: 'EUR', isEU: true },
  {
    code: 'FR',
    label: 'France',
    phone: '+33',
    currency: 'EUR',
    suggested: true,
    isEU: true,
  },
  { code: 'GF', label: 'French Guiana', phone: '+594', currency: 'EUR', noRegions: true },
  { code: 'PF', label: 'French Polynesia', phone: '+689', currency: 'XPF', noRegions: true },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '+262',
    currency: 'EUR',
    noRegions: true,
  },
  { code: 'GA', label: 'Gabon', phone: '+241', currency: 'XAF' },
  { code: 'GM', label: 'Gambia', phone: '+220', currency: 'GMD' },
  { code: 'GE', label: 'Georgia', phone: '+995', currency: 'GEL' },
  {
    code: 'DE',
    label: 'Germany',
    phone: '+49',
    currency: 'EUR',
    suggested: true,
    isEU: true,
  },
  { code: 'GH', label: 'Ghana', phone: '+233', currency: 'GHS' },
  { code: 'GI', label: 'Gibraltar', phone: '+350', currency: 'GIP', noRegions: true },
  { code: 'GR', label: 'Greece', phone: '+30', currency: 'EUR', isEU: true },
  { code: 'GL', label: 'Greenland', phone: '+299', currency: 'DKK' },
  { code: 'GD', label: 'Grenada', phone: '+1-473', currency: 'XCD' },
  { code: 'GP', label: 'Guadeloupe', phone: '+590', currency: 'EUR', noRegions: true },
  { code: 'GU', label: 'Guam', phone: '+1-671', currency: 'USD', noRegions: true },
  { code: 'GT', label: 'Guatemala', phone: '+502', currency: 'GTQ' },
  { code: 'GG', label: 'Guernsey', phone: '+44', currency: 'GBP', noRegions: true },
  { code: 'GN', label: 'Guinea', phone: '+224', currency: 'GNF' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '+245', currency: 'XOF' },
  { code: 'GY', label: 'Guyana', phone: '+592', currency: 'GYD' },
  { code: 'HT', label: 'Haiti', phone: '+509', currency: 'HTG' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '+379',
    currency: 'EUR',
    noRegions: true,
  },
  { code: 'HN', label: 'Honduras', phone: '+504', currency: 'HNL' },
  { code: 'HK', label: 'Hong Kong', phone: '+852', currency: 'HKD', noRegions: true },
  { code: 'HU', label: 'Hungary', phone: '3+6', currency: 'HUF', isEU: true },
  { code: 'IS', label: 'Iceland', phone: '+354', currency: 'ISK' },
  { code: 'IN', label: 'India', phone: '+91', currency: 'INR' },
  { code: 'ID', label: 'Indonesia', phone: '+62', currency: 'IDR' },
  { code: 'IQ', label: 'Iraq', phone: '+964', currency: 'IQD' },
  { code: 'IE', label: 'Ireland', phone: '+353', currency: 'EUR', isEU: true },
  { code: 'IM', label: 'Isle of Man', phone: '+44', currency: 'GBP', noRegions: true },
  { code: 'IL', label: 'Israel', phone: '+972', currency: 'ILS' },
  { code: 'IT', label: 'Italy', phone: '+39', currency: 'EUR', isEU: true },
  { code: 'JM', label: 'Jamaica', phone: '+1-876', currency: 'JMD' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '+81',
    currency: 'JPY',
    suggested: true,
  },
  { code: 'JE', label: 'Jersey', phone: '+44', currency: 'GBP', noRegions: true },
  { code: 'JO', label: 'Jordan', phone: '+962', currency: 'JOD' },
  { code: 'KZ', label: 'Kazakhstan', phone: '+7', currency: 'KZT' },
  { code: 'KE', label: 'Kenya', phone: '+254', currency: 'KES' },
  { code: 'KI', label: 'Kiribati', phone: '+686', currency: 'AUD' },
  { code: 'KR', label: 'Korea, Republic of', phone: '+82', currency: 'KRW' },
  { code: 'XK', label: 'Kosovo', phone: '+383', currency: 'EUR', noRegions: true },
  { code: 'KW', label: 'Kuwait', phone: '+965', currency: 'KWD' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '+996', currency: 'KGS' },
  {
    code: 'LA',
    label: "Lao People's Democratic Republic",
    phone: '+856',
    currency: 'LAK',
  },
  { code: 'LV', label: 'Latvia', phone: '+371', currency: 'EUR', isEU: true },
  { code: 'LB', label: 'Lebanon', phone: '+961', currency: 'LBP' },
  { code: 'LS', label: 'Lesotho', phone: '+266', currency: 'LSL' },
  { code: 'LR', label: 'Liberia', phone: '+231', currency: 'LRD' },
  { code: 'LY', label: 'Libya', phone: '+218', currency: 'LYD' },
  { code: 'LI', label: 'Liechtenstein', phone: '+423', currency: 'CHF' },
  { code: 'LT', label: 'Lithuania', phone: '+370', currency: 'EUR', isEU: true },
  { code: 'LU', label: 'Luxembourg', phone: '+352', currency: 'EUR', isEU: true },
  { code: 'MO', label: 'Macao', phone: '+853', currency: 'MOP', noRegions: true },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '+389',
    currency: 'MKD',
  },
  { code: 'MG', label: 'Madagascar', phone: '+261', currency: 'MGA' },
  { code: 'MW', label: 'Malawi', phone: '+265', currency: 'MWK' },
  { code: 'MY', label: 'Malaysia', phone: '+60', currency: 'MYR' },
  { code: 'MV', label: 'Maldives', phone: '+960', currency: 'MVR' },
  { code: 'ML', label: 'Mali', phone: '+223', currency: 'XOF' },
  { code: 'MT', label: 'Malta', phone: '+356', currency: 'EUR', isEU: true },
  { code: 'MH', label: 'Marshall Islands', phone: '+692', currency: 'USD' },
  { code: 'MQ', label: 'Martinique', phone: '+596', currency: 'EUR', noRegions: true },
  { code: 'MR', label: 'Mauritania', phone: '+222', currency: 'MRU' },
  { code: 'MU', label: 'Mauritius', phone: '+230', currency: 'MUR' },
  { code: 'YT', label: 'Mayotte', phone: '+262', currency: 'EUR', noRegions: true },
  { code: 'MX', label: 'Mexico', phone: '+52', currency: 'MXN' },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '+691',
    currency: 'USD',
  },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '+373',
    currency: 'MDL',
  },
  { code: 'MC', label: 'Monaco', phone: '+377', currency: 'EUR' },
  { code: 'MN', label: 'Mongolia', phone: '+976', currency: 'MNT' },
  { code: 'ME', label: 'Montenegro', phone: '+382', currency: 'EUR' },
  { code: 'MS', label: 'Montserrat', phone: '+1-664', currency: 'XCD', noRegions: true },
  { code: 'MA', label: 'Morocco', phone: '+212', currency: 'MAD' },
  { code: 'MZ', label: 'Mozambique', phone: '+258', currency: 'MZN' },
  { code: 'MM', label: 'Myanmar', phone: '+95', currency: 'MMK' },
  { code: 'NA', label: 'Namibia', phone: '+264', currency: 'NAD' },
  { code: 'NR', label: 'Nauru', phone: '+674', currency: 'AUD' },
  { code: 'NP', label: 'Nepal', phone: '+977', currency: 'NPR' },
  { code: 'NL', label: 'Netherlands', phone: '+31', currency: 'EUR', isEU: true },
  { code: 'NC', label: 'New Caledonia', phone: '+687', currency: 'XPF', noRegions: true },
  { code: 'NZ', label: 'New Zealand', phone: '+64', currency: 'NZD' },
  { code: 'NI', label: 'Nicaragua', phone: '+505', currency: 'NIO' },
  { code: 'NE', label: 'Niger', phone: '+227', currency: 'XOF' },
  { code: 'NG', label: 'Nigeria', phone: '+234', currency: 'NGN' },
  { code: 'NU', label: 'Niue', phone: '+683', currency: 'NZD', noRegions: true },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '+1-670',
    currency: 'USD',
    noRegions: true,
  },
  { code: 'NO', label: 'Norway', phone: '+47', currency: 'NOK' },
  { code: 'OM', label: 'Oman', phone: '+968', currency: 'OMR' },
  { code: 'PK', label: 'Pakistan', phone: '+92', currency: 'PKR' },
  { code: 'PW', label: 'Palau', phone: '+680', currency: 'USD' },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '+970',
    currency: 'ILS',
  },
  { code: 'PA', label: 'Panama', phone: '+507', currency: 'PAB' },
  { code: 'PG', label: 'Papua New Guinea', phone: '+675', currency: 'PGK' },
  { code: 'PY', label: 'Paraguay', phone: '+595', currency: 'PYG' },
  { code: 'PE', label: 'Peru', phone: '+51', currency: 'PEN' },
  { code: 'PH', label: 'Philippines', phone: '+63', currency: 'PHP' },
  { code: 'PN', label: 'Pitcairn', phone: '+870', currency: 'NZD', noRegions: true },
  { code: 'PL', label: 'Poland', phone: '+48', currency: 'PLN', isEU: true },
  { code: 'PT', label: 'Portugal', phone: '+351', currency: 'EUR', isEU: true },
  { code: 'QA', label: 'Qatar', phone: '+974', currency: 'QAR' },
  { code: 'RE', label: 'Reunion', phone: '+262', currency: 'EUR', noRegions: true },
  { code: 'RO', label: 'Romania', phone: '+40', currency: 'RON', isEU: true },
  { code: 'RW', label: 'Rwanda', phone: '+250', currency: 'RWF' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '+590', currency: 'EUR', noRegions: true },
  {
    code: 'SH',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    phone: '+290',
    currency: 'SHP',
  },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '+1-869',
    currency: 'XCD',
  },
  { code: 'LC', label: 'Saint Lucia', phone: '+1-758', currency: 'XCD' },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '+590',
    currency: 'EUR',
    noRegions: true,
  },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '+508',
    currency: 'EUR',
    noRegions: true,
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '+1-784',
    currency: 'XCD',
  },
  { code: 'WS', label: 'Samoa', phone: '+685', currency: 'WST' },
  { code: 'SM', label: 'San Marino', phone: '+378', currency: 'EUR' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '+239',
    currency: 'STN',
  },
  { code: 'SA', label: 'Saudi Arabia', phone: '+966', currency: 'SAR' },
  { code: 'SN', label: 'Senegal', phone: '+221', currency: 'XOF' },
  { code: 'RS', label: 'Serbia', phone: '+381', currency: 'RSD' },
  { code: 'SC', label: 'Seychelles', phone: '+248', currency: 'SCR' },
  { code: 'SL', label: 'Sierra Leone', phone: '+232', currency: 'SLL' },
  { code: 'SG', label: 'Singapore', phone: '+65', currency: 'SGD' },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '+1-721',
    currency: 'ANG',
    noRegions: true,
  },
  { code: 'SK', label: 'Slovakia', phone: '+421', currency: 'EUR', isEU: true },
  { code: 'SI', label: 'Slovenia', phone: '+386', currency: 'EUR', isEU: true },
  { code: 'SB', label: 'Solomon Islands', phone: '+677', currency: 'SBD' },
  { code: 'SO', label: 'Somalia', phone: '+252', currency: 'SOS' },
  { code: 'ZA', label: 'South Africa', phone: '+27', currency: 'ZAR' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '+500',
    currency: 'GBP',
    noRegions: true,
  },
  { code: 'SS', label: 'South Sudan', phone: '+211', currency: 'SSP' },
  { code: 'ES', label: 'Spain', phone: '+34', currency: 'EUR', isEU: true },
  { code: 'LK', label: 'Sri Lanka', phone: '+94', currency: 'LKR' },
  { code: 'SD', label: 'Sudan', phone: '+249', currency: 'SDG' },
  { code: 'SR', label: 'Suriname', phone: '+597', currency: 'SRD' },
  { code: 'SZ', label: 'Swaziland', phone: '+268', currency: 'SZL' },
  { code: 'SE', label: 'Sweden', phone: '+46', currency: 'SEK', isEU: true },
  { code: 'CH', label: 'Switzerland', phone: '+41', currency: 'CHF' },
  {
    code: 'TW',
    label: 'Taiwan',
    phone: '+886',
    currency: 'TWD',
  },
  { code: 'TJ', label: 'Tajikistan', phone: '+992', currency: 'TJS' },
  { code: 'TH', label: 'Thailand', phone: '+66', currency: 'THB' },
  { code: 'TL', label: 'Timor-Leste', phone: '+670', currency: 'USD' },
  { code: 'TG', label: 'Togo', phone: '+228', currency: 'XOF' },
  { code: 'TK', label: 'Tokelau', phone: '+690', currency: 'NZD', noRegions: true },
  { code: 'TO', label: 'Tonga', phone: '+676', currency: 'TOP' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '+1-868',
    currency: 'TTD',
  },
  { code: 'TN', label: 'Tunisia', phone: '+216', currency: 'TND' },
  { code: 'TR', label: 'Turkey', phone: '+90', currency: 'TRY' },
  { code: 'TM', label: 'Turkmenistan', phone: '+993', currency: 'TMT' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '+1-649',
    currency: 'USD',
    noRegions: true,
  },
  { code: 'TV', label: 'Tuvalu', phone: '+688', currency: 'AUD' },
  { code: 'UG', label: 'Uganda', phone: '+256', currency: 'UGX' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '+971',
    currency: 'AED',
  },
  { code: 'GB', label: 'United Kingdom', phone: '+44', currency: 'GBP' },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '+255',
    currency: 'TZS',
  },
  { code: 'UY', label: 'Uruguay', phone: '+598', currency: 'UYU' },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '+1-340',
    currency: 'USD',
    noRegions: true,
  },
  { code: 'UZ', label: 'Uzbekistan', phone: '+998', currency: 'UZS' },
  { code: 'VU', label: 'Vanuatu', phone: '+678', currency: 'VUV' },
  { code: 'VE', label: 'Venezuela', phone: '+58', currency: 'VES' },
  { code: 'VN', label: 'Vietnam', phone: '+84', currency: 'VND' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '+681', currency: 'XPF' },
  { code: 'YE', label: 'Yemen', phone: '+967', currency: 'YER' },
  { code: 'ZM', label: 'Zambia', phone: '+260', currency: 'ZMW' },
  { code: 'ZW', label: 'Zimbabwe', phone: '+263', currency: 'ZWL' },
];

const NO_CURRENCY = 'N/A';

const currencyByCountryCode = new Map(
  countries.map((country) => [country.code.toUpperCase(), country.currency.toUpperCase()]),
);

export const getCurrencyForCountry = (countryCode?: string | null): string | null => {
  if (!countryCode) return null;
  const currency = currencyByCountryCode.get(countryCode.toUpperCase());
  return currency && currency !== NO_CURRENCY ? currency : null;
};

export const usesEuroCurrency = (countryCode?: string | null): boolean =>
  getCurrencyForCountry(countryCode) === 'EUR';

export default countries;
